import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "content",
  id: "layout-article"
}

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import generalTemplate from "@/components/general-template";
import popup from "@/components/cpt-Popup/index.vue";
import popupImg from "@/components/cpt-Popup-img/index.vue";
import atention from "@/components/cpt-atention/index.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let route = useRoute();

let articleID = ref("");
if (route.query.ArticleID) {
  articleID.value = route.query.ArticleID as string;
}

watch(route, (nv, ov) => {
  articleID.value =
    articleID.value == nv.query.ArticleID
      ? articleID.value
      : (nv.query.ArticleID as string);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(generalTemplate), { articleID: _unref(articleID) }, null, 8, ["articleID"]),
    _createVNode(popup),
    _createVNode(popupImg),
    _createVNode(atention)
  ]))
}
}

})